// by 钟光燕 19 10-31
/**
 * 事件注册插件,统一管理组件事件
 */
var VueEvent = {

  install: function (Vue) {
    this.initDocmentMatchesClosest()
    let vueEvent = function (el, eventType) {
      let selectors = []

      function realHandler(event) {
        if (event.button !== 0) return;
        for (let i = 0; i < selectors.length; i++) {
          const matchElement = event.target.closest(selectors[i].selector);
          if (matchElement) {
            if (selectors[i].handler.call(matchElement, event, matchElement)) break;
          }
        }
      }
      el.addEventListener(eventType, realHandler)
      const selectorHandlers = {
        add: function (selector, handler) {
          selectors.push({
            selector,
            handler
          })
          // console.log("=====goDetail====", selector)
          return selectorHandlers;
        },
        clear: function () {
          el.removeEventListener(eventType, realHandler)
          selectors = []
        }
      }
      return selectorHandlers;
    }
    Vue.prototype.$vueEvent = vueEvent;
  },

  initDocmentMatchesClosest() {
    if (!Element.prototype.matches) {
      Element.prototype.matches = Element.prototype.webkitMatchesSelector ||
        Element.prototype.msMatchesSelector;
    }
    if (!Element.prototype.closest) {
      Element.prototype.closest = function (s) {
        let el = this;
        do {
          if (el.matches(s)) return el;
          el = el.parentElement || el.parentNode
        } while (el !== null && el.nodeType === 1)
      }
    }
  },


};
export default VueEvent



// WEBPACK FOOTER //
// ./src/plugin/vue-event.js